import { CART_STORE_KEY, VALIDATION_STORE_KEY } from '@woocommerce/block-data';
import { useEffect, useState } from '@wordpress/element';
import { useDispatch, useSelect } from '@wordpress/data';
import ServicePointSelector from './components/ServicePointSelector';

export const ServicePointSelectorBlock = ({ checkoutExtensionData, extensions }) => {
  const store = useSelect(CART_STORE_KEY);

  const storeShippingRates = store.getShippingRates();

  const [shippingRates, setShippingRates] = useState([]);

  const { clearValidationError } = useDispatch(VALIDATION_STORE_KEY);

  useEffect(() => {
    const mergedShippingRates = [];

    storeShippingRates.forEach((shippingRate) => {
      mergedShippingRates.push(shippingRate);
    });

    // Make support for subscriptions by including subscription carts
    extensions.subscriptions?.forEach((subscription) => {
      subscription.shipping_rates.forEach((shippingRate) => {
        mergedShippingRates.push(shippingRate);
      });
    });

    const shipmondoServicePointMethodSelected = mergedShippingRates.some((shippingPackage) =>
      shippingPackage?.shipping_rates?.some(
        (rate) =>
          rate?.method_id === 'shipmondo' &&
          rate?.selected &&
          typeof rate?.meta_data?.find((e) => e.key === 'is_service_point_delivery' && e.value) !== 'undefined'
      )
    );

    if (!shipmondoServicePointMethodSelected) {
      clearValidationError('shipmondo_service_point');
    }

    setShippingRates(mergedShippingRates);
  }, [storeShippingRates, extensions?.subscriptions]);

  useEffect(() => {
    return () => {
      clearValidationError('shipmondo_service_point');
    };
  }, []);

  return (
    <>
      {shippingRates.map((shippingPackage) => (
        <ServicePointSelector
          shippingPackage={shippingPackage}
          checkoutExtensionData={checkoutExtensionData}
          displayPackageTitle={shippingRates.length > 1}
          key={shippingPackage.package_id}
        />
      ))}
    </>
  );
};
